export function getAuthHeaders(extra?: HeadersInit): HeadersInit {
    const token = sessionStorage.getItem("authToken");

    return {
        ...(extra || {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
}